module.exports = `
query byUser ($params: [Params], $searchType: String,  $order: Ordering, $limit: Int) {
  searchCommon(params: $params, searchType: $searchType,  order: $order, limit: $limit){
    id _type
  }
}
`;
